import { NgModule } from "@angular/core";
import { RouterModule, PreloadAllModules, Routes } from "@angular/router";

const routes: Routes = [
    {
        path: 'register',
        loadChildren: () => import('./chrome/register/register.module').then(m => m.RegisterPageModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./chrome/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'lvb-media-screens',
        loadChildren: () => import('./lvb-media-screens/lvb-media-screens.module').then(m => m.LvbMediaScreensPageModule)
    },
    {
        path: 'lvb-media-screens',
        loadChildren: () => import('./lvb-media-screens/lvb-media-screens.module').then(m => m.LvbMediaScreensPageModule),
        outlet: 'mobile'
    },
    {
        path: 'messages',
        loadChildren: () => import('./messages/messages/messages.module').then(m => m.MessagesPageModule)
    },
    {
        path: 'messages',
        loadChildren: () => import('./messages/messages/messages.module').then(m => m.MessagesPageModule),
        outlet: 'mobile'
    },
    {
        path: 'message-details',
        loadChildren: () => import('./messages/message-details/message-details.module').then(m => m.MessageDetailsPageModule)
    },
    {
        path: 'message-details',
        loadChildren: () => import('./messages/message-details/message-details.module').then(m => m.MessageDetailsPageModule),
        outlet: 'mobile'
    },
    {
        path: 'mails',
        loadChildren: () => import('./mails/mails/mails.module').then(m => m.MailsPageModule),
        outlet: 'mobile'
    },
    {
        path: 'mails',
        loadChildren: () => import('./mails/mails/mails.module').then(m => m.MailsPageModule)
    },
    {
        path: 'mail-details/:id',
        loadChildren: () => import('./mails/mail-details/mail-details.module').then(m => m.MailDetailsPageModule),
        outlet: 'mobile'
    },
    {
        path: 'mail-details/:id',
        loadChildren: () => import('./mails/mail-details/mail-details.module').then(m => m.MailDetailsPageModule)
    },
    {
        path: 'site-simulation',
        loadChildren: () => import('./chrome/site-simulation/site-simulation.module').then(m => m.SiteSimulationPageModule)
    },
    {
        path: 'create-account',
        loadChildren: () => import('./chrome/create-account/create-account.module').then(m => m.CreateAccountPageModule)
    },
    {
        path: 'contact',
        loadChildren: () => import('./chrome/contact/contact.module').then(m => m.ContactPageModule)
    },
    {
        path: 'verification-modal',
        loadChildren: () => import('../../modals/verification-modal/verification-modal.module').then(m => m.VerificationModalPageModule)
    },
    {
        path: 'enter-validation-code',
        loadChildren: () => import('./chrome/enter-validation-code/enter-validation-code.module').then(m => m.EnterValidationCodePageModule)
    },
    {
        path: 'forgot-password',
        loadChildren: () => import('./chrome/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
    },
    {
        path: 'account-created',
        loadChildren: () => import('./chrome/account-created/account-created.module').then(m => m.AccountCreatedPageModule)
    },
    {
        path: 'forget-mail-send',
        loadChildren: () => import('./chrome/forget-mail-send/forget-mail-send.module').then(m => m.ForgetMailSendPageModule)
    },
    {
        path: 'new-password',
        loadChildren: () => import('./chrome/new-password/new-password.module').then(m => m.NewPasswordPageModule)
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ExperienceRoutingModule {}